import * as React from 'react';
import ReactDOM from 'react-dom';
import removeBottomSheet from './removeBottomSheet';
import { BottomSheetAnimatedStateful } from '../components/BottomSheetAnimatedStateful';
import { BottomSheetAnimatedWrapperProps } from '../schema/BottomSheetAnimatedProps';
import {
    getBottomSheetAnimatedDiv,
    isBottomSheetAnimatedOpen,
} from './bottomSheetAnimatedDivUtils';

/**
 * This function is used to show a bottom sheet with the given jsx element
 */
export function showBottomSheet(
    props: BottomSheetAnimatedWrapperProps,
    ref?: React.RefObject<any>
): void {
    const { id, onUnmounted, ...remainingProps } = props;
    const sheetRef = ref ?? React.createRef();

    // if it is already open, close the sheet
    if (isBottomSheetAnimatedOpen(id)) {
        removeBottomSheet(ref);
    }

    const onUnmountedWrapper = () => {
        removeBottomSheet(ref);
        onUnmounted && onUnmounted();
    };
    const bottomSheetDiv = getBottomSheetAnimatedDiv(id);

    ReactDOM.render(
        <BottomSheetAnimatedStateful
            id={id}
            onUnmounted={onUnmountedWrapper}
            hideOnOverlayClick={true}
            {...remainingProps}
            ref={sheetRef}
        />,
        bottomSheetDiv
    );

    sheetRef?.current?.open();
}

export default showBottomSheet;
